const siSymbols = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

/**
 * Returns abbreviated number.
 * Examples:
 *   2486 => 2.5k
 *   4570000 => 4.6M
 *
 * @param {number} number Input number.
 * @param {number} digits The number of digits to appear after the decimal point.
 * @returns {string}      Formatted number.
 */
export default (number, digits = 0) => {
    const tier = Math.log10(Math.abs(number)) / 3 | 0;

    if (0 === tier) {
        return number;
    }

    const suffix = siSymbols[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = number / scale;

    return scaled.toFixed(digits) + suffix;
};
